import { createStore } from 'vuex'
import { user, UserState } from './modules/user'
import { load, LoadState } from '@/store/modules/loading'

export interface GlobalProp {
  user: UserState
  load: LoadState
}

export default createStore({
  modules: { user, load }
})
